// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"149":"d98f1fbf","236":"d98f1fbf","587":"acc6fe9c"}[chunkId] + ".css";
};